import { ConditionalCardProps } from './types'
import { Card } from '@boltenergy-be/design-system'

const ConditionalCard = ({ asCard, children, className }: ConditionalCardProps) => {
  return asCard ? <Card className={className}>{children}</Card> : <div className={className}>{children}</div>
}

export default ConditionalCard
